export class EnableGarantiaRequest {
  public id_Garantia!: number
}
